export default [

     {
          path: '/escalation-rule',
          name: 'EscalationRule',
          component: () => import("@/views/Page/EscalationRule/EscalationRule.vue"),
           meta: {
               title: 'EscalationRule',
          },
     }
];